import React from "react";
import PropTypes from "prop-types";

import { ContainerBody } from "./styled";

function LayoutEdicion({ children }) {
  return <ContainerBody id="layout">{children}</ContainerBody>;
}

LayoutEdicion.propTypes = {
  children: PropTypes.element.isRequired,
};

export default LayoutEdicion;
